import React, { useState } from "react";
import { Link } from "react-router-dom";
import towing from "../../assets/images/towing.svg";
import Whitelogo from "../../assets/images/White-logo.svg";
import { Formik } from "formik";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import { APIURL } from "./../../redux/action/config";
import PhoneInput from "react-phone-input-2";

const PasswordReset = () => {
  const resetForms = () => {
    document.getElementById("myForm").reset();
  };
  const currentYear = new Date().getFullYear();
  const [phoneNumber, setPhoneNumber] = useState(null);

  return (
    <React.Fragment>
      <div className="d-flex flex-column flex-root">
        <ToastContainer autoClose={2000} />
        <div className="d-flex flex-column flex-lg-row flex-column-fluid">
          <div
            className="d-flex flex-column flex-lg-row-auto bg-primary w-xl-600px positon-xl-relative banner-height"
            style={{ height: "100vh" }}
          >
            <div className="d-flex flex-column position-xl-fixed top-0 bottom-0 w-xl-600px scroll-y">
              <div className="d-flex flex-row-fluid flex-column text-center p-10 pt-lg-20">
                <Link to="#" className="py-9 pt-lg-20">
                  <img alt="Logo" src={Whitelogo} className="h-40px" />
                </Link>
                <h1 className="fw-bolder text-white fs-2qx pb-5 pb-md-10">
                  Welcome to Roadside
                </h1>
                <p className="fw-bold fs-2 text-white">
                  Emergency Roadside Assistance for Every Bahamas Motorist
                </p>
              </div>
              <div
                className="d-flex flex-row-auto bgi-no-repeat bgi-position-x-center bgi-size-contain bgi-position-y-bottom min-h-100px min-h-lg-350px"
                style={{
                  backgroundImage: `url(${towing})`,
                }}
              ></div>
            </div>
          </div>
          <div className="d-flex flex-column flex-lg-row-fluid py-10">
            <div className="d-flex flex-center flex-column flex-column-fluid mb-20">
              <div className="w-lg-500px p-10 p-lg-15 mx-auto w-100">
                <Formik
                  initialValues={{
                    phone: phoneNumber,
                  }}
                  onSubmit={(values, { setSubmitting, resetForm }) => {
                    values.phone = phoneNumber;
                    // const regex = /^([+]\d{2})?\d{10}$/;
                    // if (regex.test(values.phone)) {
                    var myHeaders = new Headers();
                    myHeaders.append("Content-Type", "application/json");

                    var raw = JSON.stringify({
                      phone: `${values.phone}`,
                    });

                    var requestOptions = {
                      method: "POST",
                      headers: myHeaders,
                      body: raw,
                      redirect: "follow",
                    };

                    fetch(
                      `${APIURL}/api/v1/users/sendForgotPasswordOTP`,
                      requestOptions
                    )
                      .then((response) => response.json())
                      .then((result) => {
                        if (result.status === "success") {
                          setSubmitting(false);
                          resetForm();
                          resetForms();
                          localStorage.setItem(
                            "phone",
                            JSON.parse(`${values.phone}`)
                          );
                          toast.success(result.message);
                          // alert(result.otp);
                          setTimeout(() => {
                            return (window.location.href = "/verify-otp");
                          }, 1000);
                        } else {
                          toast.error(result.message);
                        }
                      })
                      .catch((error) => toast.error(error.message));
                    // } else {
                    //   toast.error("Please enter a valid phone number!");
                    // }
                  }}
                >
                  {({
                    values,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    errors,
                    touched,
                  }) => (
                    <form
                      className="form  w-100"
                      onSubmit={handleSubmit}
                      id="myForm"
                    >
                      <div className="text-center mb-10">
                        <h1 className="text-dark mb-3">Forgot Password ?</h1>
                        <div className="text-gray-400 fw-bold fs-4">
                          Enter your mobile number to reset your password
                        </div>
                      </div>
                      <div className="fv-row mb-10">
                        <label className="form-label fs-6 fw-bolder text-dark">
                          Phone Number{" "}
                          {/* <span className="text-gray-400 fw-bold fs-6">
                            (With Country Code)
                          </span> */}
                        </label>
                        {/* <input
                          name="phone"
                          autoFocus
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className="form-control form-control-lg form-control-solid"
                          placeholder="Enter 10 digit mobile number"
                        /> */}

                        <PhoneInput
                          inputProps={{
                            name: "mobile",
                          }}
                          inputStyle={{
                            width: "100%",
                            height: "42px",
                            background: "#f8f6f2",
                            border: "none",
                            borderRadius: "0.95rem",
                          }}
                          country={"bs"}
                          onChange={(e) => setPhoneNumber(e)}
                        />
                      </div>
                      <div className="d-flex flex-wrap justify-content-center pb-lg-0">
                        <button
                          type="button"
                          id="kt_password_reset_submit"
                          className="btn btn-lg btn-primary fw-bolder me-4"
                          onClick={handleSubmit}
                        >
                          <span className="indicator-label">Submit</span>
                          <span className="indicator-progress">
                            Please wait...
                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                          </span>
                        </button>
                        <Link
                          to="/"
                          className="btn btn-lg btn-light-primary fw-bolder"
                        >
                          Cancel
                        </Link>
                      </div>
                    </form>
                  )}
                </Formik>
              </div>
            </div>
            <div className="d-flex flex-center flex-wrap fs-6 p-5 pb-0">
              <div className="d-flex flex-center fw-bold fs-6">
                <p>{currentYear} © Copyright All rights reserved.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default PasswordReset;
